import axios from "axios";
import Qs from "qs";

const paramsSerializer = function (params) {
  return Qs.stringify(params, { arrayFormat: "comma", encode: false });
};

const PRODUCTION = "production";
const STAGE = "stage"; //TODO rip out CRA for this
const DEVELOPMENT = "development";

export const htpmdVersion = "1.0.1";

const createReactAppEnv = process.env.NODE_ENV; //eslint-disable-line no-undef
//create react app limits possible environments and does not include stage.
//till we remove create react app we will determine staging with a hacky flag
const staging = process.env.REACT_APP_STAGE; //eslint-disable-line no-undef

if (createReactAppEnv === undefined) {
  throw Error("Attempted to build without node env");
}

function getEnvironment() {
  if (staging === "stage") {
    return STAGE;
  } else if (createReactAppEnv === PRODUCTION) {
    return PRODUCTION;
  } else {
    return DEVELOPMENT;
  }
}

function getBaseURL(env) {
  return "/api";
}
// todo setup production server
const environment = getEnvironment();
if ([PRODUCTION, STAGE, DEVELOPMENT].includes(environment) === false) {
  throw Error(`Invalid NODE_ENV: "${environment}"`);
}
export const baseURL = getBaseURL(environment);

// CORS requests on a local filesystem are a pain, don't use a baseURL
export const api = baseURL.match(/localhost/)
  ? axios
  : axios.create({
      baseURL,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });

// TODO Remove authorization args for public facing site.
function createHeaders({ accessToken }) {
  return {
    Authorization: `Bearer ${accessToken}`,
  };
}

export function fetchSampleParameters({ accessToken }) {
  return api.get(`/samples/search-parameters`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchSamplesAggregate() {
  return api.get(`/samples/aggregate`);
}

export function fetchSampleFormulations({ sample_id, accessToken }) {
  return api.get(`/samples/${sample_id}/formulations`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchSampleProvenance({ sample_id, accessToken }) {
  return api.get(`/samples/${sample_id}/provenance`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchSampleProperties({ sample_id, accessToken }) {
  return api.get(`/samples/${sample_id}/properties`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchSampleProfilometerXYSlices({ sample_id, accessToken }) {
  return api.get(`/samples/${sample_id}/profilometer-x-y-slices`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchSampleProcessCSV({ sample_id, process_name, accessToken }) {
  return api.get(`/samples/${sample_id}/csv/${process_name}`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchConductivityVsSaltWeightFraction() {
  return api.get(`/samples/conductivity-vs-salt-weight-fraction`);
}

export function fetchConductivityVsEisTemperature1000T({ accessToken }) {
  return api.get(`/samples/conductivity-vs-eis-temperature-1000t`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchTrajectoryParameters({ htpmd_version, accessToken }) {
  return api.get(`/trajectories/search-parameters`, {
    params: { "htpmd-version": htpmd_version },
    headers: createHeaders({ accessToken }),
    paramsSerializer,
  });
}

export function fetchTrajectoryAggregate({ htpmd_version, accessToken }) {
  return api.get(`/trajectories/aggregate`, {
    params: { "htpmd-version": htpmd_version },
    headers: createHeaders({ accessToken }),
    paramsSerializer,
  });
}

export function fetchTrajectoryLiMsdCurve({ trajectory_id, accessToken }) {
  return api.get(`/trajectories/${trajectory_id}/li-msd-curve`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchTrajectoryTfsiMsdCurve({ trajectory_id, accessToken }) {
  return api.get(`/trajectories/${trajectory_id}/tfsi-msd-curve`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchTrajectoryStructure({ trajectory_id, accessToken }) {
  return api.get(`/trajectories/${trajectory_id}/structure`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchTrajectoryConditions({ trajectory_id, accessToken }) {
  return api.get(`/trajectories/${trajectory_id}/conditions`, {
    headers: createHeaders({ accessToken }),
  });
}

export function fetchTrajectoryRawDataLink({ trajectoryId }) {
  return api.get(`/trajectories/${trajectoryId}/raw`);
}
